export default __webpack_public_path__ + "locales/pl/Files.json?hash=49508c5f1c366f00fe60aa8b6e1d5bff";